import { assignTokens } from '@sail/engine';
import { ButtonConfig, css, tokens } from '@sail/ui';
import { helmTokens } from '../tokens';
export const buttonCustomization = ButtonConfig.customize({
    css: {
        paddingX: 'medium',
        transition: `all ${helmTokens.transition.hover}`,
        height: '33px',
        paddingTop: '3px',
        paddingBottom: 'space.75',
        boxShadow: 'none',
        lineHeight: 1.6,
        letterSpacing: `${helmTokens.letterSpacing.large}`,
        ':focus': {
            boxShadow: 'none'
        },
        ':active': {
            border: 'none',
            keyline: 'none'
        },
        ':hover': {
            transitionDuration: 'medium'
        }
    },
    uses: [
        assignTokens(tokens.animation.easing, 'cubic-bezier(0.215, 0.61, 0.355, 1)')
    ],
    defaults: {
        type: 'primary'
    },
    // This code won't be necessary once we fix an issue in our Button component
    variants: {
        type: {
            primary: css({
                transitionProperty: 'background-color, opacity'
            }),
            secondary: css({
                transitionProperty: 'color, opacity',
                paddingX: '0'
            })
        }
    }
});

//# sourceMappingURL=button.js.map